<template>
  <div class="w-h rPos">
    <!-- 这是首页... -->
    
    <!-- <videoupload 
      v-s.height='600'
      type='dialog' 
      title='我的Dialog对话框 - 注册账号' 
      show='boolean2'
      @update:show='(info,comp)=>{}'
      @close=''
      >
      <div >
        <i title="置顶" onclick='App.$refs.Myrouterview.style.overflow=""' class="el-icon-s-home font18 cPointer" style="position: absolute;right: 21px;top: 13px;color: rosybrown;"></i>
        <el-input placeholder='饿了么输入框...没有v-model'></el-input>
      </div>
    </videoupload> -->
    <!-- <keep-alive> -->
      <mymenu 
        id='__mykeepmenu__'
        keepalive
        xxxyyy
        inputstyle='box-shadow:rgba(128, 128, 128, 0.62) 1px 1px 3px 1px;height:40px;' 
        style='position: relative;left: 0px;width: 100%;'
        ></mymenu>
    <!-- </keep-alive> -->

  </div>
</template>
<script>

// let collapseMenu;
export default {
  // components: {
  //   headers,
  //   navs,
  // },
  
  data() {
    return {
      headerHeight: 47,
      activeDate: 1,
      Appload: false,
    };
  },

  created() {
    const str = JSON.parse(A.local("$Userinfo"));
    console.error(str);
    str.roleList.forEach((item,index)=>{
      if(item.roleName === '大屏查看'){
         this.$router.push({ name: 'BigScreenDisplay'})
      } 
    })
   
   
    // ( collapseMenu||(collapseMenu=App.collapseMenu) )();
  },

  activated() {
    // collapseMenu();
  },

  mounted: function() {
    // let boxHeight = document.documentElement.clientHeight;
    // this.headerHeight = document.getElementsByClassName(
    //   "headers"
    // )[0].offsetHeight;
    // this.mainHeight = boxHeight - this.headerHeight;
  },
};

</script>


<style xscoped>
  
  #__mykeepmenu__ .fullscreenSelect {
    left: 0px !important;
    width: 100%!important;
    z-index: 777!important;
    display: block!important;
  }
  
  #__mykeepmenu__ .fullscreenSelect .el-scrollbar__wrap {
    height: calc( 100vh - 110px );
    max-height: 92vh;
  }

</style>



// WEBPACK FOOTER //
// src/views/home.Homepage.Closemenu.vue